import { LOCAL_STORAGE_CHAVE_PF } from '@/config/constantes'

import gerarIdHashProductFruits from './gerar-id-hash-product-fruits'

export function obterUsuarioProductFruits(login?: string): string {
  if (!login) {
    let hashUnica = localStorage.getItem(LOCAL_STORAGE_CHAVE_PF)

    if (!hashUnica) {
      hashUnica = gerarIdHashProductFruits(8)
      localStorage.setItem(LOCAL_STORAGE_CHAVE_PF, hashUnica)
    }

    return `usuario-nao-autenticado-${hashUnica}`
  }

  return login
}
